/** @jsx jsx */
import { jsx } from "theme-ui"
import Svg from "./base"

const Icon = props => (
  <Svg width="488" height="264" {...props}>
    <circle cx="21.63" cy="95.234" r="21.63" fill="#05F"></circle>
    <circle cx="21.63" cy="21.63" r="21.63" fill="#AFB0B3"></circle>
    <circle cx="21.63" cy="168.587" r="21.63" fill="#05F"></circle>
    <circle cx="21.63" cy="241.944" r="21.63" fill="#05F"></circle>
    <circle cx="94.985" cy="95.234" r="21.63" fill="#05F"></circle>
    <circle cx="94.985" cy="21.63" r="21.63" fill="#AFB0B3"></circle>
    <circle cx="94.985" cy="168.587" r="21.63" fill="#05F"></circle>
    <circle cx="94.985" cy="241.944" r="21.63" fill="#05F"></circle>
    <circle cx="168.34" cy="95.234" r="21.63" fill="#05F"></circle>
    <circle cx="168.34" cy="21.63" r="21.63" fill="#AFB0B3"></circle>
    <circle cx="168.34" cy="168.587" r="21.63" fill="#05F"></circle>
    <circle cx="168.34" cy="241.944" r="21.63" fill="#05F"></circle>
    <circle cx="245.457" cy="95.234" r="21.63" fill="#05F"></circle>
    <circle cx="245.457" cy="21.63" r="21.63" fill="#AFB0B3"></circle>
    <circle cx="245.457" cy="168.587" r="21.63" fill="#05F"></circle>
    <circle cx="245.457" cy="241.944" r="21.63" fill="#05F"></circle>
    <circle cx="318.812" cy="95.234" r="21.63" fill="#05F"></circle>
    <circle cx="318.812" cy="21.63" r="21.63" fill="#AFB0B3"></circle>
    <circle cx="318.812" cy="168.587" r="21.63" fill="#05F"></circle>
    <circle cx="318.812" cy="241.944" r="21.63" fill="#05F"></circle>
    <circle cx="392.167" cy="95.234" r="21.63" fill="#05F"></circle>
    <circle cx="392.167" cy="21.63" r="21.63" fill="#AFB0B3"></circle>
    <circle cx="392.167" cy="168.587" r="21.63" fill="#05F"></circle>
    <circle cx="392.167" cy="241.944" r="21.63" fill="#05F"></circle>
    <circle cx="465.522" cy="95.234" r="21.63" fill="#05F"></circle>
    <circle cx="465.522" cy="21.63" r="21.63" fill="#AFB0B3"></circle>
    <circle cx="465.522" cy="168.587" r="21.63" fill="#05F"></circle>
    <circle cx="465.522" cy="241.944" r="21.63" fill="#05F"></circle>
  </Svg>
)

export default Icon
